import {config as dateColumnConfig} from '../../../common/DateColumn';

export const prop = 'engPerEndDate';
export const id = 'endDateOfPeriodCoveredColumn';

export const config = (labels) =>
	dateColumnConfig({fullId: id, label: labels.endDateOfPeriodCovered, prop, width: 'minmax(var(--px-170), 1fr)'});
